import React, { useState, useEffect } from 'react';
import { gql, useMutation, useQuery } from "@apollo/client";
import '../App.css';

const CREAR_PRODUCTO = gql`
mutation crearProducto($nombre: String, $imagen: String, $precio: Int, $codigo: String, $stock: Int) {
  crearProducto(nombre: $nombre, imagen: $imagen, precio: $precio, codigo: $codigo, stock: $stock) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
  }
}`;

const GET_PRODUCTO = gql`
query getProductos {
  getProductos {
    _id
    nombre
    imagen
    precio
    codigo
    stock
  }
}`;

const ACTUALIZAR_PRODUCTO = gql`
mutation editarProducto($id: ID!, $nuevoNombre: String, $nuevaImagen: String, $nuevoCodigo: String, $nuevoStock: Int, $nuevoPrecio: Int) {
  editarProducto(_id: $id, nombre: $nuevoNombre, imagen: $nuevaImagen, codigo: $nuevoCodigo, stock: $nuevoStock, precio: $nuevoPrecio) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
  }
}`;

function VerificaryAgregar() {
  const { loading, error, data } = useQuery(GET_PRODUCTO);

  const [searchCodigo, setSearchCodigo] = useState(''); // Estado para el campo de búsqueda
  const [filteredProducts, setFilteredProducts] = useState([]); // Estado para los productos filtrados

  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState(0);
  const [stock, setStock] = useState(0);
  const [codigo, setCodigo] = useState('');
  const [imagen, setImagen] = useState('');
  const [crearProducto] = useMutation(CREAR_PRODUCTO, {
    refetchQueries: [{ query: GET_PRODUCTO }],
  });

  const productoSubmit = e => {
    e.preventDefault();
    crearProducto({ variables: { nombre, precio, stock, codigo, imagen } });
    setNombre('');
    setPrecio(0);
    setStock(0);
    setCodigo('');
    setImagen('');
  };

  useEffect(() => {
    if (data && searchCodigo) {
      const filtered = data.getProductos.filter(producto => producto.codigo.includes(searchCodigo));
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [searchCodigo, data]);

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  return (
    <div>
      <div className="card card-salida">
        <div className="card-body">
          <h2 className="card-title">Buscar producto por código</h2>
          <input 
            placeholder="Buscar por código" 
            value={searchCodigo} 
            onChange={e => setSearchCodigo(e.target.value)} 
          />
        </div>
      </div>

      <div className="container">
        <div className="row">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((producto) => (
              <div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" key={producto._id}>
                <div className="card-body">
                  <h3 className="card-title">{producto.nombre}</h3>
                  <img src={producto.imagen} width="50px" alt="" />
                  <h4 className="card-text">${producto.precio}</h4>
                  <h4 className="card-text">Stock: {producto.stock}</h4>
                  <p className="card-text">Código: {producto.codigo}</p>
                </div>
              </div>
            ))
          ) : (
            searchCodigo && <p>No se encontraron productos.</p>
          )}
        </div>
      </div>

      <div className="card card-salida">
        <div className="card-body">
          <h2 className="card-title">Agregar producto</h2>
          <form onSubmit={productoSubmit}>
            <h6>Producto</h6>
            <input placeholder='nombre' value={nombre} onChange={evt => setNombre(evt.target.value)}></input>
            <h6>Precio</h6>
            <input placeholder='precio' value={precio} onChange={evt => setPrecio(parseInt(evt.target.value))}></input>
            <h6>Codigo de barras</h6>
            <input placeholder='codigo' value={codigo} onChange={evt => setCodigo(evt.target.value)}></input>
            <h6>Stock</h6>
            <input placeholder='stock' value={stock} onChange={evt => setStock(parseInt(evt.target.value))}></input>
            <h6>Url de la imagen</h6>
            <input placeholder='imagen' value={imagen} onChange={evt => setImagen(evt.target.value)}></input>
            <button className="btn btn-salida">Agregar producto</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default VerificaryAgregar;
